import { WorksheetsResultsMessagesSection } from 'Components/Worksheets/Core';
import { IQuantity } from 'Data/ViewModels/Core/IQuantity';
import { hasNonEmptyValue } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent } from '../../../Core/types';
let AsLinearShrinkageResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const UnableToMeasure = useSelector(createWorksheetSelector!('Measurements.UnableToMeasure'));
  const NegativeLongitudinalShrinkage = useSelector(
    pipe(
      createWorksheetSelector!('Measurements.LongitudinalShrinkage'),
      (s: IQuantity) => hasNonEmptyValue(s) && Number(s.value) < 0
    )
  );
  return (
    <>
      <WorksheetsResultsMessagesSection />
      <ListFieldSection>
        <Field
          input={<TextOutput />}
          visible={UnableToMeasure || NegativeLongitudinalShrinkage}
          name={'Measurements.LinearShrinkageText'}
        />
        <Field
          input={<TextOutput />}
          visible={!UnableToMeasure && !NegativeLongitudinalShrinkage}
          name={'Measurements.LinearShrinkage'}
        />
      </ListFieldSection>
    </>
  );
};

AsLinearShrinkageResultsSection = withInjectedProps(AsLinearShrinkageResultsSection);

export { AsLinearShrinkageResultsSection };
export default AsLinearShrinkageResultsSection;
